import { Button } from "@design-system/Inputs/Button";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { KnowledgeBaseItemType } from "@generated/client/graphql";
import { Link, useParams } from "react-router-dom";
import { button_props } from "../../ctx";
import { useKnowledgeBasePageTranslations } from "../../i18n";

export const EditButtons = ({
    activeType,
}: {
    activeType: KnowledgeBaseItemType;
}) => {
    const { button_text, to } = button_props[activeType];
    return (
        <FlexRow gap="2" alignItems="end">
            <EditButton button_text={button_text} to={to} />
        </FlexRow>
    );
};

const EditButton = ({
    button_text,
    to,
}: {
    button_text: string[];
    to: (orgUname?: string) => string[];
}) => {
    const { t } = useKnowledgeBasePageTranslations();
    const { org_uname } = useParams();

    return (
        <FlexRow gap="3" alignItems="end">
            {button_text.map((button_text, index) => (
                <Link
                    className="[all:unset] no-underline ![text-decoration:none]"
                    to={to(org_uname)[index]}
                    key={button_text}
                >
                    <Button variant="outlined" size="sm">
                        <FlexRow gap="2">
                            <Text variant="body-sm-bold">{t(button_text)}</Text>
                            <Button.Icon name="external" size="sm" />
                        </FlexRow>
                    </Button>
                </Link>
            ))}
        </FlexRow>
    );
};
